// extracted by mini-css-extract-plugin
export default {"richTextEditorRoot":"RichTextEditorField_richTextEditorRoot__Mx0Ao"};